import { MsgService } from './../share/msg/msg.service';
import { SERVICE_ROLES } from './../../environments/environment';
import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot, Router } from '@angular/router';
import { Observable } from 'rxjs';
import { AuthenticateService } from '../share/authenticate/authenticate.service';
import { tap } from 'rxjs/operators';
import * as MSG from '../share/msg/msg';

@Injectable()
export class AuthGuard implements CanActivate {

  constructor(
    private authServ: AuthenticateService,
    private msgServ: MsgService,
    private router: Router,
   ) {}

  canActivate( route: ActivatedRouteSnapshot, state: RouterStateSnapshot ): Observable<boolean> | boolean {
    this.authServ.inputUrl = '';
    return this.authServ.isAuthenticated().pipe(
      tap(loggedIn => {
        // ログアウト状態(cognito認証ができない)
        if (!loggedIn) {
          console.warn('not authenticated cognito user.');
          this.authServ.jumpToLoginPage();
        // トークンに埋め込まれる権限に不備あり
        } else if (!this.isHadSmile9Auth()) {
          this.authServ.signOut();
          setTimeout(() => {
            this.msgServ.warning(MSG.DANGER.NO_AUTH, '');
          }, 1000); // 遅延実行しないと、ページ遷移時のトースター削除処理で消されてしまう
        }
      })
    );
  }

  private isHadSmile9Auth(): boolean {
    if (!this.authServ.smile9Role) {
      console.warn('no smile9 role.');
      return false;
    }

    switch (this.authServ.serviceRole) {
      case SERVICE_ROLES.USER:
        return true;
      case SERVICE_ROLES.FSC:
        // 給食Cは権限不要
        return true;
      case SERVICE_ROLES.SYSTEM:
        // 開発者は権限不要
          return true;
      default:
        console.warn('no valid service role.');
        return false;
    }
  }
}

